import { Flex, Stack } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import SummaryOfBenefitsLink from './SummaryOfBenefitsLink';

const PlanDetails = ({ title, plan }) => {
  return (
    <Stack>
      <Body1 bold>{title}</Body1>
      <Flex flexDir={['column', 'column', 'row']} gap={4}>
        <Body1>{plan.name}</Body1>
        <Flex>
          <SummaryOfBenefitsLink cms_id={plan.cms_id} effective_date={plan.effective_date} />
        </Flex>
      </Flex>
    </Stack>
  );
};

export default PlanDetails;
